module.exports = __webpack_public_path__ + "static/media/js.ddaea1d8.png";